import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import Byo from './Byo.jsx'
import { clearState } from '../store/byoSlice'

const defaultProps = {
  
}
document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.querySelector('#BuildYourOwn')
  if(appContainer) {
    let propsRaw = appContainer.getAttribute('props')
    if(propsRaw.description) {
      propsRaw.description = propsRaw.description.replace(/'/g, 'T');
    }
    let props = JSON.parse(propsRaw)
    const finalProps = Object.assign(defaultProps, props)
    const root = createRoot(appContainer)
    root.render(
      <Provider store={store}>
        <Byo data={finalProps} />
      </Provider>)
  }
})